module.exports = __webpack_public_path__ + "static/img/logo.c476a19.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build901/assets/images/common/logo.png
// module id = yq8Z
// module chunks = 47